<template>
  <router-view/>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';

export default {
  name: 'MeitavDash',
  created() {
    this.setPhoneNumber(this.phoneNumber);
    this.setFirstName(this.firstName || this.activeMemberFirstName);
    this.setLastName(this.lastName || this.activeMemberLastName);
    this.setEmail(this.email || this.activeMemberEmail);
  },
  computed: {
    ...mapState('signup', ['firstName', 'lastName', 'email']),
    ...mapState('authentication', ['phoneNumber']),
    ...mapGetters('session', ['activeMemberFirstName', 'activeMemberLastName', 'activeMemberEmail']),
  },
  methods: {
    ...mapMutations('meitavDash/openFund', ['setPhoneNumber', 'setFirstName', 'setLastName', 'setEmail']),
  },
};
</script>
